
// src/api/app_urls.js
import CommonSettings from "../utils/CommonSettings";

class APPUrls {
  constructor() {
    this.initUrls(CommonSettings.SERVER_BASE_URL);
  }

  // ✅ Called whenever CommonSettings.setBaseURL() changes
  initUrls(baseUrl) {
    this.API_BASE_URL = baseUrl;
    this.FIXED_BASE_URL = CommonSettings.FIXED_BASE_URL;

    // Meta Data APIs
    this.GET_DRS_TYPES = `${baseUrl}meta-data/get-drs-types`;
    this.GET_DEPLOYMENT_SYSTEMS = `${baseUrl}meta-data/get-deployment-systems`;

    // DRS Matches
    this.ADD_DRS_MATCH = `${baseUrl}drsmatches/add-drs-match`;
    this.GET_DRS_MATCH = `${baseUrl}drsmatches/get-drs-matches`;

    // DRS Balls
    this.ADD_DRS_BALL = `${baseUrl}drsballs/add-drs-ball`;
    this.GET_DRS_BALL = `${baseUrl}drsballs/get-drs-balls`;

    // Score / Video URLs
    this.VIDEO_URLS = `${baseUrl}score/match-video-url`;
  }
}

const APPUrlsInstance = new APPUrls();
export default APPUrlsInstance;

// Export ready-to-use constants
export const {
  API_BASE_URL,
  FIXED_BASE_URL,
  GET_DRS_TYPES,
  GET_DEPLOYMENT_SYSTEMS,
  ADD_DRS_MATCH,
  GET_DRS_MATCH,
  ADD_DRS_BALL,
  GET_DRS_BALL,
  VIDEO_URLS,
} = APPUrlsInstance;


